export default "__VITE_ASSET__B6qR6HBJ__"